<template>
  <div class="mt-12 flex flex-col items-center">
    <NuxtIcon
      name="mdi:question-mark-circle-outline"
      class="mt-20 mb-10 w-30 h-30 text-neutral-300" />
    />
    <h1
      class="max-w-2xl text-center text-8xl font-bold tracking-tight text-secondary-500">
      404
    </h1>
    <h2
      class="max-w-2xl text-center text-4xl font-bold tracking-tight text-neutral-200">
      {{ $t("main.notFound404.itemNotFound") }}
    </h2>
    <p class="mt-2 max-w-sm px-2 text-center text-base text-neutral-300">
      {{ $t("main.notFound404.resourceNotFound") }}
    </p>
    <div class="mt-6 max-w-2xl text-center flex items-center justify-center">
      <NuxtLinkLocale to="/">
        <BaseButtonSubmit
          :text="$t('main.notFound404.backToHomepage')"
          size="xl"
          data-test="button-item-404-to-homepage" />
      </NuxtLinkLocale>
    </div>
  </div>
</template>
